import React, { useEffect, useState } from "react";
import MarsAdminTable from "./MarsAdminTable";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Collapse } from "react-collapse";
import { getToken } from "../../auth/authConfig";
import axios from "axios";
import "./MarsAdmin.scss";
import { Alert, Box } from "@mui/material";
import { login } from "../../auth/msalAuth";

const MarsAdmin = () => {
  const [expanded, setExpanded] = useState([false, false, false, false, true]);
  const [initialFormData, setInitialFormData] = useState(null);
  const [intialFormLoading, setInitialFormLoading] = useState(false);
  const [initialFormError, setInitialFormError] = useState(false);
  const [completedFormData, setCompletedFormData] = useState(null);
  const [error, setError] = useState(false);

  const handleToggle = (index) => {
    setExpanded((prev) =>
      prev.map((value, i) => (i === index ? !value : value))
    );
  };

  const getFormListDetails = async () => {
    const getInitialFormURL = `${process.env.REACT_APP_SERVER_URL}/api/listing/all_forms`;
    const token = await getToken();
    setInitialFormLoading(true);
    try {
      const response = await axios.get(getInitialFormURL, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });

      if (response.status === 200) {
        setInitialFormData([]);
        setInitialFormLoading(false);

        const json = response.data;

        const initiatedForms = json && json.initaited_forms;
        const Completed = json && json.completd_forms;
        setInitialFormData(initiatedForms || []);
        setCompletedFormData(Completed || []);
      
      } else {
        setInitialFormError("Oops! Something went wrong. . .");
        setInitialFormLoading(false);
      }
    } catch (e) {
      setInitialFormLoading(false);
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
      setInitialFormError("Oops! Something went wrong. . .");
    }
    // finally {
    //   setInitialFormError(false);
    // }
  };

  useEffect(() => {
    getFormListDetails();
  }, []);

  // useEffect(() => {
  //   if (AuditData) {
  //     setAuditedForm(AuditData.AuditedForm || []);
  //     setAuditVersioning(AuditData.AuditVersioning || []);
  //     setAuditCompleted(AuditData.AuditCompleted || []);
  //     setAuditBackForm(AuditData.AuditBackForm || []);
  //   }
  // }, [AuditData]);

  return (
    <>
      <div id="mars-verification" className="mars-verification-section">
        <div className="mars-Audited-init-sections mars-verification-common">
          <div className="collapse-section">
            <h3 className="main-heading">List of Initiated Forms</h3>
            <div className="collapse-btn" onClick={() => handleToggle(4)}>
              {expanded[4] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </div>
          </div>

          <Collapse isOpened={expanded[4]}>
            <MarsAdminTable
              loading={intialFormLoading}
              error={initialFormError}
              tableData={initialFormData || []}
              title="List of Initiated forms"
              color="darkYellow"
              expand={expanded[4]}
              view={true}
              download={false}
              colorValue="b8aa36"
              buttonView="#f5f5cd"
              buttonText="#433e13"
              viewDate={false}
              inCompleteFlag={true}
              hideyearqater={true}
            />
          </Collapse>
        </div>

      

        <div className="mars-AuditedCompleted-Forms-sections mars-verification-common">
          <div className="collapse-section">
            <h3 className="main-heading">List of Audit Completed Forms</h3>
            <div className="collapse-btn" onClick={() => handleToggle(2)}>
              {expanded[2] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </div>
          </div>

          <Collapse isOpened={expanded[2]}>
            <MarsAdminTable
              loading={intialFormLoading}
              error={initialFormError}
              tableData={completedFormData || []}
              title="List of Audit Completed Forms"
              color="green"
              expand={expanded[2]}
              view={true}
              download={true}
              colorValue="769711"
              buttonView="#d8e5ad"
              buttonText="#41530b"
              viewDate={true}
              inCompleteFlag={false}
              hideyearqater={false}
            />
          </Collapse>
        </div>
      </div>
      {error && (
        <Box
          sx={{
            position: "fixed",
            top: 55,
            right: 16,
            zIndex: 1300, // Ensures it appears above other content
          }}
        >
          <Alert
            severity="error"
            sx={{
              fontSize: "20px",
              width: "auto",
            }}
          >
            Something went wrong! Please try again later.
          </Alert>
        </Box>
      )}
    </>
  );
};

export default MarsAdmin;
